import React, { useRef } from 'react';
import cn from 'classnames';
import { useIsOverflow } from './hooks/useIsOverflow';

const EllipsisHandler = ({ tooltipTitle, className, children }) => {
  const ref = useRef();
  const isOverflow = useIsOverflow(ref);
  const classes = cn('truncate', className);
  let tooltipProps;

  if (tooltipTitle && isOverflow) {
    tooltipProps = {
      'data-toggle': 'tooltip',
      title: tooltipTitle,
      'data-placement': 'top',
    };
  }

  return (
    <div ref={ref} className={classes} {...tooltipProps}>
      {children}
    </div>
  );
};

export default EllipsisHandler;
